// Bottom gutter for scroll areas.
//
// On a phone the browser's own bottom bar (and the home indicator on notched
// devices) sits over the last few pixels of the page. The app shell is sized to the
// visible viewport, so the end of a list is reachable, but it ends up flush against
// that bar and is hard to read or tap. Every page-level scroll area therefore keeps
// a little extra room after its last row.
//
// Spread this LAST in an sx object: a plain `p` declared after it would otherwise
// win over the padding-bottom.
export const scrollAreaSx = {
  WebkitOverflowScrolling: 'touch',
  overscrollBehavior: 'contain' as const,
  pb: { xs: 'calc(30px + env(safe-area-inset-bottom))', md: '16px' },
} as const;
